import { useEffect } from 'react';

export const useResponsiveBaseFont = (): void => {
  useEffect(() => {
    const updateFont = (): void => {
      const size = window.innerWidth <= 1920 ? 14 : 16;
      document.documentElement.style.fontSize = `${size}px`;
    };

    updateFont();
    window.addEventListener('resize', updateFont);
    return () => window.removeEventListener('resize', updateFont);
  }, []);
};
